var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M426.324 39.61C419.79 16.77 398.738 0 373.828 0s-45.96 16.77-52.5 39.61H0v30h321.332c6.535 22.835 27.586 39.609 52.496 39.609s45.961-16.774 52.5-39.61H512v-30zm-52.496 39.609c-13.57 0-24.61-11.04-24.61-24.61S360.263 30 373.829 30c13.57 0 24.61 11.04 24.61 24.61s-11.04 24.609-24.61 24.609zM96.152 125.48c-24.91 0-45.96 16.774-52.496 39.61H0v30h43.656c6.535 22.84 27.59 39.61 52.5 39.61s45.961-16.77 52.496-39.61H512v-30H148.652c-6.535-22.836-27.59-39.61-52.5-39.61zm0 79.22c-13.566 0-24.605-11.04-24.605-24.61 0-13.567 11.039-24.61 24.605-24.61 13.57 0 24.61 11.043 24.61 24.61 0 13.57-11.04 24.61-24.61 24.61zM264.41 250.965c-24.91 0-45.965 16.77-52.5 39.61H0v30h211.91c6.535 22.835 27.59 39.609 52.5 39.609 24.906 0 45.961-16.774 52.496-39.61H512v-30H316.906c-6.535-22.84-27.59-39.61-52.496-39.61zm0 79.219c-13.57 0-24.61-11.04-24.61-24.61s11.04-24.61 24.61-24.61c13.567 0 24.61 11.04 24.61 24.61s-11.04 24.61-24.61 24.61zm0 0",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.637899bd842cb5371688aa2eee22ea5f.svg";
export { ForwardRef as ReactComponent };